import { render } from "./FunctionalityCustomer.vue?vue&type=template&id=dfdf9df6"
import script from "./FunctionalityCustomer.vue?vue&type=script&lang=js"
export * from "./FunctionalityCustomer.vue?vue&type=script&lang=js"

import "./FunctionalityCustomer.vue?vue&type=style&index=0&id=dfdf9df6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__